/**
 * Canonical product route names for `/store/products/:product`.
 * Keep in sync with store module routing / StoreDataResolver.
 */
export const STORE_KNOWN_PRODUCTS = [
  'EuroMillions',
  'Lotto',
  'Megamillions',
  'SuperenaLotto',
  'Eurojackpot',
  'PowerBall',
  'Irish Lotto',
  'ThunderBall',
  'FrenchLotto',
  'LottoMax',
  'LaPrimitiva',
  'Lotto6aus49',
] as const;

export type StoreKnownProductName = (typeof STORE_KNOWN_PRODUCTS)[number];

/** Collapse spaces/hyphens so "Power Ball", "Powerball", and "PowerBall" match. */
export function normalizeStoreProductName(name: string): string {
  return name.replace(/[\s-]/g, '').toLowerCase();
}

export function findKnownStoreProduct(urlParam: unknown): StoreKnownProductName | null {
  if (urlParam === null || urlParam === undefined) {
    return null;
  }

  const trimmed = String(urlParam).trim();
  if (!trimmed) {
    return null;
  }

  const normalized = normalizeStoreProductName(trimmed);
  if (!normalized) {
    return null;
  }

  return (
    STORE_KNOWN_PRODUCTS.find(
      (product) => normalizeStoreProductName(product) === normalized
    ) ?? null
  );
}

/** True when `/store/products/:name` resolves to a known store product. */
export function hasKnownStoreProductRoute(productName: unknown): boolean {
  return findKnownStoreProduct(productName) !== null;
}
